import * as React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PatchReviewDialog({ open, onClose, data }) {
  const reportText = data?.report_text || "";
  const todos = data?.todos || [];
  const runnerOutput = data?.runner_output || "";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>Patch Assistant – Proposed Changes</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>Runner Output</Typography>
          <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{runnerOutput}</pre>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>Report</Typography>
          <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{reportText}</pre>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>TODO Files</Typography>
          {todos.length === 0 ? (
            <Typography variant="body2" color="text.secondary">No TODOs were generated.</Typography>
          ) : (
            todos.map((t, i) => (
              <Accordion key={i} defaultExpanded={i === 0}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle2">{t.path}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{t.content}</pre>
                </AccordionDetails>
              </Accordion>
            ))
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
}
